import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable()
export class VerboseErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (!environment.production) {
      console.error('Angular error detail:', this.describeError(error), error);
    }

    console.error(error);
  }

  private describeError(error: unknown): unknown {
    if (error instanceof Error) {
      return {
        name: error.name,
        message: error.message,
        stack: error.stack,
      };
    }

    if (error && typeof error === 'object') {
      return {
        prototype: Object.getPrototypeOf(error)?.constructor?.name,
        keys: Object.keys(error),
        json: this.stringify(error),
      };
    }

    return error;
  }

  private stringify(value: unknown): string {
    try {
      return JSON.stringify(value);
    } catch {
      return 'No se pudo serializar el error.';
    }
  }
}
